import type { EmployeeStatus } from "./types";

export const STATUS_META: Record<
  EmployeeStatus,
  { label: string; color: string; ring: string; dot: string }
> = {
  home: {
    label: "At home",
    color: "text-emerald-300",
    ring: "ring-emerald-400/40",
    dot: "bg-emerald-400",
  },
  relocated: {
    label: "Relocated",
    color: "text-amber-300",
    ring: "ring-amber-400/40",
    dot: "bg-amber-400",
  },
  in_transit: {
    label: "In transit",
    color: "text-sky-300",
    ring: "ring-sky-400/40",
    dot: "bg-sky-400",
  },
  unknown: {
    label: "Unknown",
    color: "text-slate-400",
    ring: "ring-slate-500/40",
    dot: "bg-slate-500",
  },
};

export function timeAgo(iso: string | null): string {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const m = Math.floor(diff / 60_000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}
